import React from "react";

const SitePolicy = () => (
  <div className="container py-5">
    <h1 className="mb-4">Site Policy</h1>
    <h2 className="h5 mt-4">1. Privacy</h2>
    <p>
      We respect your privacy. This site does not collect personal information unless you choose to contact us or use a form. Any information you provide is used only to respond to your inquiry and is never sold or shared with third parties.
    </p>
    <h2 className="h5 mt-4">2. Cookies & Analytics</h2>
    <p>
      This site may use cookies or analytics tools to improve your experience and understand how the site is used. No personally identifiable information is tracked.
    </p>
    <h2 className="h5 mt-4">3. User Content</h2>
    <p>
      If you submit content (such as comments, audio, or feedback), you agree that it may be used to improve the site or its services. Please do not submit sensitive or confidential information.
    </p>
    <h2 className="h5 mt-4">4. AI & Audio Features</h2>
    <p>
      The VoiceLoop AI Agent uses OpenAI's API for audio transcription and transcript refinement. When you use these features, your audio is securely sent to OpenAI's API endpoint for processing.
      <br />
      <strong>We do not store your audio or transcripts after processing is complete.</strong>
      <br />
      For details on how OpenAI handles and processes data sent to their API, please review the{" "}
      <a
        href="https://platform.openai.com/docs/guides/your-data"
        target="_blank"
        rel="noopener noreferrer"
      >
        OpenAI API Data Usage & Privacy
      </a>.
      <br />
      If you have concerns about your privacy or data usage, we recommend reviewing OpenAI’s documentation or contacting us for more information.
    </p>
    <h2 className="h5 mt-4">5. External Links</h2>
    <p>
      This site may link to third-party sites. We are not responsible for their content or privacy practices.
    </p>
    <h2 className="h5 mt-4">6. Changes</h2>
    <p>
      This policy may be updated from time to time. Please check back for updates.
    </p>
    <h2 className="h5 mt-4">7. Contact</h2>
    <p>
      For questions or concerns, please <a href="/contact">contact us</a>.
    </p>
  </div>
);

export default SitePolicy;